import { computed, inject, Injectable, Signal } from '@angular/core';

import { HasPermissionsService } from '@connect-services/client/services/has-permissions.service';
import { PermissionAliasEnum } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionPermissionService {
    public readonly canManageFieldIntervention = computed((): boolean => {
        if (!this.initialized()) {
            return false;
        }

        return this.hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_FIELD_INTERVENTION]);
    });
    public readonly canReadFieldIntervention = computed((): boolean => {
        if (!this.initialized()) {
            return false;
        }

        return this.hasPermissionsService.checkPermissions([PermissionAliasEnum.READ_FIELD_INTERVENTION]);
    });
    public readonly initialized: Signal<boolean> = computed(() => this.hasPermissionsService.initialized());

    private readonly hasPermissionsService = inject(HasPermissionsService);
}
